const childRoutes = (prop) => [{
        path: 'test',
        name: prop + '.test',
        meta: { auth: true },
        component: () => import('../pages/Test.vue')
    },
    {
        path: 'manual-category',
        name: prop + '.manual-category',
        meta: { auth: true },
        component: () => import('../pages/manual-category/List.vue')
    },
    {
        path: 'manual-sub-category',
        name: prop + '.manual-sub-category',
        meta: { auth: true },
        component: () => import('../pages/manual-sub-category/List.vue')
    },
    {
        path: 'service',
        name: prop + '.service',
        meta: { auth: true },
        component: () => import('../pages/service/List.vue')
    },
    {
        path: 'service-type',
        name: prop + '.service-type',
        meta: { auth: true },
        component: () => import('../pages/service-type/List.vue')
    }
]
const routes = [{
    path: '/social-welfare-service/configuration',
    name: 'social_welfare_service.configuration',
    component: () => import('@/layouts/SocialWelfareServiceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('social_welfare_service.configuration')
}]
export default routes
